import { ChakraProps, chakra } from '@chakra-ui/react';
import { useMemo } from 'react';
import {
  MultiPolygon2,
  Point2,
} from '../../../domain/geometry/geometric-types';
import {
  getPolygon2PathData,
  transformMultipolygonCoordinates,
} from '../shapes/util';

type PolygonProps = {
  multipolygon: MultiPolygon2;
  getPointInDomCoordinateSystem: (pointInPdf: Point2) => Point2;
  strokeWidth?: number;
  fillOpacity?: number;
  strokeOpacity?: number;
  onClick?: React.MouseEventHandler;
  selectable?: boolean;
} & ChakraProps;
export const SheetPolygon = ({
  multipolygon,
  getPointInDomCoordinateSystem,
  strokeWidth,
  fillOpacity,
  strokeOpacity,
  onClick,
  selectable,
  ...rest
}: PolygonProps) => {
  const pathData = useMemo(() => {
    return transformMultipolygonCoordinates(
      multipolygon,
      getPointInDomCoordinateSystem
    ).polygons.map((polygon) => getPolygon2PathData(polygon));
  }, [getPointInDomCoordinateSystem, multipolygon]);

  return (
    <chakra.svg
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      pointerEvents={selectable ? undefined : 'none'}
      _hover={{ filter: selectable ? 'brightness(1.05)' : undefined }}
      opacity={strokeWidth ? 1 : 0.7}
      fillRule={'evenodd'}
      strokeWidth={strokeWidth}
      fillOpacity={fillOpacity}
      strokeOpacity={strokeOpacity}
    >
      {pathData.map((data, index) => (
        <chakra.path
          key={index}
          d={data}
          onClick={onClick}
          data-shape-urn={selectable ? 'urn' : undefined} // If the data-shape-urn is set, the polygon can be selected
          {...rest}
        />
      ))}
    </chakra.svg>
  );
};
